import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import './Checkout.css';

const Checkout = ({ price, email, buyerName, id }) => {
    const [cardError, setCardError] = useState('')
    const [success, setSuccess] = useState("");
    const [processing, setProcessing] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [clientSecret, setClientSecret] = useState("");
    const stripe = useStripe();
    const elements = useElements();


    useEffect(() => {
        fetch('https://cell-swap-server.vercel.app/create-payment-intent', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ price: parseInt(price.slice(1)) })
        })
            .then(res => res.json())
            .then(data => setClientSecret(data.clientSecret))
    }, [])


    const handleSubmit = async e => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        const card = elements.getElement(CardElement);

        if (card === 'null') {
            return;
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card
        })
        if (error) {
            setCardError(error.message)
        } else {
            setCardError('');
        }
        setSuccess('')
        setProcessing(true)

        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: card,
                billing_details: {
                    name: buyerName,
                    email: email
                }
            }
        })

        if (confirmError) {
            setCardError(confirmError.message)
        }

        if (paymentIntent.status === 'succeeded') {
            setSuccess('Congrats! your payment has been succeeded!')
            setTransactionId(paymentIntent.id)

            const slice = parseInt(price.slice(1))
            const payment = {
                price: slice,
                transactionId: paymentIntent.id,
                email: email,
                bookingId: id
            }

            fetch('https://cell-swap-server.vercel.app/payments', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify(payment)
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                    toast.success('Payment Successfull. Wait for Shipment.')
                })
        }
        setProcessing(false)

    }
    return (
        <>
            <form onSubmit={handleSubmit}>
                <CardElement
                    options={{
                        style: {
                            base: {
                                fontSize: '16px',
                                color: '#424770',
                                '::placeholder': {
                                    color: '#aab7c4',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
                <button className='pay-btn' type="submit" disabled={!stripe || !clientSecret || processing}>
                    Pay
                </button>
            </form>
            <p className='text-red-500'>{cardError}</p>
            {
                success &&
                <div>
                    <p className='text-green-500'>{success}</p>
                    <p>Your transaction id <span className='font-bold'>{transactionId}</span></p>
                </div>
            }
        </>
    );
};

export default Checkout;